// Custom Manufacturing page English translations

export default {
  pageTitle: "Custom Manufacturing",
  breadcrumbHome: "Home",
  breadcrumbServices: "Services",
  breadcrumbCurrent: "Custom Manufacturing",
  
  // Service links
  customManufacturing: "Custom Manufacturing",
  technicalSupport: "Technical Support",
  afterSalesService: "After-Sales Service",
  qualityAssurance: "Quality Assurance",
  researchDevelopment: "Research & Development",
  globalSupplyChain: "Global Supply Chain",
  
  // Main content
  title: "Custom Manufacturing Solutions",
  description1: "At PT Eagle Industry Indonesia, we specialize in providing custom manufacturing solutions tailored to meet the unique requirements of our clients across various industries. Our advanced manufacturing capabilities and experienced engineering team enable us to deliver high-quality precision components that exactly match your specifications.",
  description2: "With decades of experience in precision manufacturing, we have developed expertise in producing complex mechanical components that meet the most demanding industry standards. Our custom manufacturing process combines state-of-the-art technology with traditional craftsmanship to ensure exceptional quality and performance.",
  
  // Capabilities section
  capabilitiesTitle: "Our Custom Manufacturing Capabilities:",
  capabilities: [
    "Precision machining with tolerances as tight as ±0.001mm",
    "Custom material selection and sourcing based on application requirements",
    "Prototype development and rapid iteration for design optimization",
    "Small batch to large volume production capabilities",
    "Complex geometries and multi-axis machining capabilities",
    "Surface treatment and finishing processes to enhance performance"
  ],
  
  // Industry applications
  industryApplicationsTitle: "Industry Applications:",
  industryApplications: "Our custom manufacturing solutions serve a diverse range of industries, including automotive, aerospace, marine, oil and gas, semiconductor manufacturing, and industrial machinery. We understand the unique challenges and requirements of each industry and develop customized solutions that address specific operational needs.",
  
  // Metrics
  manufacturingPrecision: "Manufacturing Precision",
  manufacturingPrecisionDesc: "Industry-leading tolerances and quality standards",
  materialExpertise: "Material Expertise",
  materialExpertiseDesc: "Wide range of materials including specialized alloys",
  productionFlexibility: "Production Flexibility",
  productionFlexibilityDesc: "Scalable solutions from prototype to mass production",
  qualityAssuranceMetric: "Quality Assurance",
  qualityAssuranceMetricDesc: "Rigorous testing and inspection processes",
  
  // Process section
  processTitle: "Our Manufacturing Process:",
  processDescription: "Our custom manufacturing process begins with a thorough understanding of your requirements and application challenges. Our engineering team collaborates closely with clients to develop detailed specifications and design optimizations. We then utilize our advanced manufacturing facilities to produce components that meet exact specifications, followed by comprehensive quality testing to ensure performance and reliability.",
  
  // CTA button
  discussRequirements: "Discuss Your Custom Requirements",
  
  // Related services section
  relatedServicesTitle: "Related Services",
  relatedServicesDescription: "Explore our other comprehensive services",
  technicalSupportDesc: "Expert technical assistance to ensure optimal performance of our products.",
  qualityAssuranceDesc: "Rigorous quality control processes ensuring international standards compliance.",
  researchDevelopmentDesc: "Continuous innovation to develop advanced sealing solutions.",
  readMore: "Read more"
};